import { NavLink, useLocation, useParams } from 'react-router-dom';
import { Box, NavItem } from '@optiaxiom/react';

import CanInstance from '@frontend/components/CanInstance';
import CanUser from '@frontend/components/CanUser';
import { FeatureFlag } from '@frontend/contexts';
import { InstanceOperationsName, OperationsName } from '@frontend/types';

import * as styles from './NavigationItem.css';

type NavigationItemProps = {
  path: string;
  icon: JSX.Element;
  label: string;
  permissions: OperationsName[];
  instanceCapabilities?: InstanceOperationsName[];
  featureFlag?: string;
  showIndicator?: boolean;
};

/* TODO: Add doc string */
export const NavigationItem = ({
  path,
  icon,
  label,
  permissions,
  instanceCapabilities = [],
  featureFlag,
  showIndicator = false,
}: NavigationItemProps) => {
  const location = useLocation();
  const { instanceId } = useParams();
  const selectedRoute = location.pathname.split('/')[3] || 'chat';

  const navItem = (
    <NavLink
      to={`/instances/${instanceId}/${path}`}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <Box className={styles.navItemContainer}>
        <NavItem active={selectedRoute === path} icon={icon}>
          {label}
        </NavItem>
        {showIndicator && <Box className={styles.unreadIndicator} />}
      </Box>
    </NavLink>
  );

  const withPermission = <CanUser operations={permissions}>{navItem}</CanUser>;

  const withCapabilities =
    instanceCapabilities.length > 0 ? (
      <CanInstance capabilities={instanceCapabilities}>{withPermission}</CanInstance>
    ) : (
      withPermission
    );

  if (featureFlag) {
    return <FeatureFlag featureKey={featureFlag}>{withCapabilities}</FeatureFlag>;
  }

  return withCapabilities;
};
